__turbopack_context__.v({
  "animationBase": "_2cWx_q_animationBase",
  "stage": "_2cWx_q_stage",
});
